import React from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import defaultFases from "../../constants/DefaultFases";
import FaseContainer from "../../containers/results/FaseContainer";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const Fases = (props) => (
  <div
    style={{
      marginBottom: 12,
      marginTop: 5,
    }}
  >
    {Object.keys(props.fasesPerDivision).length > 0 && (
      <Typography
        variant="h6"
        style={{ fontWeight: 500, paddingTop: 20, paddingBottom: 5 }}
      >
        {languages.results.progress}
      </Typography>
    )}
    <div
      style={{
        whiteSpace: "nowrap",
        overflowX: "auto",
        display: "flex",
        alignItems: "flex-start",
      }}
    >
      {Object.keys(props.fasesPerDivision)
        .sort((aKey, bKey) => {
          let a = props.divisionsObject[aKey] || {};
          let b = props.divisionsObject[bKey] || {};
          if (a.num > b.num) {
            return 1;
          } else if (a.num < b.num) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          } else if (a.id < b.id) {
            return -1;
          } else {
            return 0;
          }
        })
        .map((key, i) => {
          const division = props.divisionsObject[key] || {};
          division["id"] = key;
          let fases = props.fasesPerDivision[key];
          return (
            <Card
              key={key}
              style={{ margin: 3, padding: 5, overflow: "visible" }}
            >
              <CardContent style={{ padding: 10 }}>
                {Object.keys(props.fasesPerDivision).length > 1 && (
                  <Typography variant="subtitle2" style={{ marginBottom: 5 }}>
                    {division.name || ""}
                  </Typography>
                )}
                <div
                  style={{
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {Object.keys(fases).map((faseKey, i) => {
                    let fase = fases[faseKey];
                    let nextFase = (division.fases || defaultFases)[
                      Object.keys(fases)[i + 1]
                    ];
                    if (nextFase) {
                      nextFase["id"] = Object.keys(fases)[i + 1];
                    }
                    let nextNextFase = (division.fases || defaultFases)[
                      Object.keys(fases)[i + 2]
                    ];
                    return (
                      <FaseContainer
                        key={key + i}
                        {...props}
                        division={division}
                        fase={fase}
                        nextFase={nextFase}
                        faseKey={faseKey}
                        nextNextFase={nextNextFase}
                      />
                    );
                  })}
                </div>
              </CardContent>
            </Card>
          );
        })}
    </div>
  </div>
);

export default Fases;
